import { render, staticRenderFns } from "./UploadArquivos.vue?vue&type=template&id=ca03d3de&"
import script from "./UploadArquivos.vue?vue&type=script&lang=js&"
export * from "./UploadArquivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports